module.exports = __webpack_public_path__ + "9a7407fb4ff20e1457078a1a6c8221f3.svg";